import React from "react";
import "./RupaliHealth.scss";
import rupaliHealthBg from "../../../assets/rupali-health-bg.jpg";

import opdImg4 from "../../../assets/opd-img4.png";
import opdSheba from "../../../assets/opd-sheba.png";
import { Link } from "react-router-dom";

const RupaliHealth = () => {
  return (
    <>
      <div className="rupali_health">
        <div className="container-fluid p-0">
          <div className="rupali_health_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6" data-aos="zoom-out-right">
                  <img src={opdImg4} className="img-fluid " alt="" />
                </div>
                <div className="col-lg-6 my-auto" data-aos="fade-left">
                  <img src={opdSheba} className="img-fluid" alt="" />
                  <div className="text-center mt-5">
                    <a
                      href="https://rupalihealth.com/"
                      target="_blank"
                      rel="noreferrer"
                      to="https://rupalihealth.com/"
                      className="btn main_btn"
                    >
                      <span className="btn_text"> Get Appointment</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="" data-aos="fade-down" data-aos-duration="500">
            <img src={rupaliHealthBg} className="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </>
  );
};

export default RupaliHealth;
